import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { distinctUntilChanged } from 'rxjs'

import type { BoxSizeCallback } from '../../hooks/useResizeObserver'

const [cartFooterHeight$, setCartFooterHeight] = createSignal<number>()

export const [useLatestCartFooterHeight] = bind(cartFooterHeight$.pipe(distinctUntilChanged()), 0)

export const setCartFooterHeightFromBoxSize: BoxSizeCallback = (size) => {
  setCartFooterHeight(size?.height ?? 0)
}
